import interactiveContentAPI from '@/api/interactiveContentAPI'

export const interactiveContentStore = {
    namespaced: true,

    state: {},

    getters: {},

    actions: {

        async createInteractiveContent({ commit, state }, data) {
            return await interactiveContentAPI.createInteractiveContent(data)
        },

        async saveInteractiveContent({ commit, state }, { interactive_content_id, data }) {
            return await interactiveContentAPI.saveInteractiveContent({ interactive_content_id, data })
        },

        async removeInteractiveContent({ commit, state }, interactive_content_id) {
            return await interactiveContentAPI.removeInteractiveContent(interactive_content_id)
        },

    },

    mutations: {},
}
